import React, { useState, useEffect } from "react"

interface IDelayedRenderProps {
  timeoutMs?: number
  children: React.ReactNode
}

export function DelayedRender({ timeoutMs, children }: IDelayedRenderProps) {
  const [render, setRender] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => setRender(true), timeoutMs ?? 500)
    return () => clearTimeout(timeout)
  })

  return <React.Fragment>{render ? children : null}</React.Fragment>
}
